import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {InvoiceSummary, Transaction} from "@app/shared";
import {Observable} from "rxjs/internal/Observable";

@Injectable({
  providedIn: 'root'
})
export class LegacyInvoiceService {

  constructor(private http: HttpClient) { }

  getExistingInvoices(transaction: Transaction):Observable<InvoiceSummary[]> {
    let url = `/finance/legacy-invoices?transaction=${transaction}`;
    return this.http.get<InvoiceSummary[]>(url);
  }

  saveOrUpdateInvoice(invoiceSummary: InvoiceSummary ): Observable<InvoiceSummary>{
    let url = `/finance/legacy-invoices`;
    return this.http.post<InvoiceSummary>(url, invoiceSummary);
  }

  importInvoices(invoiceSummary: InvoiceSummary[] ): Observable<InvoiceSummary[]>{
    let url = `/finance/legacy-invoices/import`;
    return this.http.post<InvoiceSummary[]>(url, invoiceSummary);
  }
}
